import React from "react";
import style from "css/admin/component.module.css";

function SearchInput({
    value,
    onChange,
    placeholder = "",
    type = "text",
    className = "",
    fullWidth = false,
    width,
    style: styleProp,
    ...rest
}) {
    const mergedStyle =
        width != null
            ? { width, ...(styleProp || {}) }
            : styleProp;
    return (
        <input
            type={type}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            className={`${style.search_input} ${fullWidth ? style.fullWidth : ""} ${className}`}
            style={mergedStyle}
            {...rest}
        />
    );
}

export default SearchInput;

